import Vue from 'vue';
import App from './App.vue';
import Router from './router';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import { storeConfig } from './store';
import plugins from './plugins/index.js';
import { sync } from 'vuex-router-sync';
import shopify from '@/plugins/shopify.js';

// import the styles
import 'vue-good-table/dist/vue-good-table.css';

import '@/styles/style.scss';

Vue.use(Vuetify);
const { vuetify } = plugins.setupVuePlugins(Vue);

const store = new Vuex.Store(storeConfig);
const router = Router.setup(store);

Vue.prototype.$shopify = shopify.setup();

sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
